(function () {
  'use strict';
  var root = document.getElementById('voltra-site-update-popup');
  if (!root) return;
  var expires = Date.parse(root.getAttribute('data-expires') || '');
  var key = root.getAttribute('data-storage-key') || 'voltra_site_update_popup_v6';
  if (isFinite(expires) && Date.now() >= expires) return;

  function todayKey() {
    var d = new Date();
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var day = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + day;
  }

  try {
    if (window.localStorage && localStorage.getItem(key) === todayKey()) return;
  } catch (_) {}

  function markSeenToday() {
    try { if (window.localStorage) localStorage.setItem(key, todayKey()); } catch (_) {}
  }

  function dismiss() {
    root.setAttribute('hidden', '');
    root.hidden = true;
    markSeenToday();
    document.removeEventListener('keydown', onKey);
  }
  function onKey(ev) { if (ev.key === 'Escape') dismiss(); }

  root.querySelectorAll('[data-voltra-popup-dismiss]').forEach(function (el) {
    el.addEventListener('click', dismiss);
  });
  document.addEventListener('keydown', onKey);
  // Mark on show so home/frontpage revisits the same day don't re-pop.
  markSeenToday();
  root.removeAttribute('hidden');
  root.hidden = false;
})();
